import { all } from 'redux-saga/effects'
import userResourcesSaga from './userResourcesSaga'
import resourceEmbedConfigSaga from './resourceEmbedConfigSaga'
import extendedUserSaga from './extendedUserSaga'

export default function* rootSaga(){
    yield all([
        userResourcesSaga(),
        resourceEmbedConfigSaga(),
        extendedUserSaga()
    ])
}